import { z } from 'zod'
import { BacktestRunStatus } from '../../enums/backtest-run-status.enum'
import { backtestConfigSchema, daySettingsSchema } from './backtest-config.schema'
import { backtestResultSchema } from './backtest-result.schema'

export const backtestRunStatusDtoSchema = z.object({
  jobId: z.string(),
  status: z.nativeEnum(BacktestRunStatus),
  progress: z.object({
    done: z.number().int(),
    total: z.number().int(),
  }),
  createdAt: z.coerce.date(),
  finishedAt: z.coerce.date().nullable(),
  error: z.string().nullable(),
  config: backtestConfigSchema,
  result: backtestResultSchema.nullable(),
})

export type BacktestRunStatusDto = z.infer<typeof backtestRunStatusDtoSchema>

export const backtestRunSummarySchema = z.object({
  jobId: z.string(),
  createdAt: z.coerce.date(),
  finishedAt: z.coerce.date().nullable(),
  status: z.nativeEnum(BacktestRunStatus),
  instrumentCount: z.number().int(),
  netPnl: z.number().nullable(),
  afterTaxNet: z.number().nullable(),
  from: z.coerce.date(),
  to: z.coerce.date(),
  // name of the preset the run used, or null for custom settings
  preset: z.string().nullable(),
  // global (account-level) strategy settings for this run
  defaults: daySettingsSchema,
  // user-authored freetext note for this run
  comment: z.string().nullable().optional(),
})

export type BacktestRunSummaryDto = z.infer<typeof backtestRunSummarySchema>

export const setBacktestCommentSchema = z.object({
  comment: z.string().max(2000),
})

export type SetBacktestCommentDto = z.infer<typeof setBacktestCommentSchema>
